import { GO_BACK_PREFIX, PREV_LINK_STORE, ROOT_ROUTE } from '../core/constants';

/**
 * Pull out the stored previous link from localStorage, or return
 * the fallback.
 *
 * @param {string} fallback
 * @param {string} storeKey
 * @returns {string}
 */
export const getLinkFromLocalStorage = (fallback: string = ROOT_ROUTE, storeKey: string = PREV_LINK_STORE) => {
  const stored = getLink(storeKey, false);

  if (!stored) {
    return fallback;
  }

  return stored;
};

/**
 * Pull the key from localStorage, and remove the store if desired.
 *
 * @param {string} storeKey
 * @param {boolean} remove
 * @returns {string | null}
 */
export const getLink = (storeKey: string, remove = true): string | null => {
  const key = `${GO_BACK_PREFIX}:${storeKey}`;
  const stored = localStorage.getItem(key);

  if (!stored) {
    return null;
  }

  if (remove) {
    localStorage.removeItem(key);
  }

  return stored;
};

/**
 * Store the current path in localStorage.
 * @param {string} storeKey
 */
export const storeCurrentLocation = (storeKey: string = PREV_LINK_STORE) => {
  localStorage.setItem(`${GO_BACK_PREFIX}:${storeKey}`, window.location.pathname);
};
